import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import Logger from '@/lib/logger';
import UserAgent from '@/lib/user-agent';

var colonToDash = function colonToDash(value) {
  return value.replace(/:/g, '-');
};

var WebkitCallback = /*#__PURE__*/function () {
  function WebkitCallback() {
    _classCallCheck(this, WebkitCallback);
  }

  _createClass(WebkitCallback, null, [{
    key: "audioPause",
    value: function audioPause(id) {
      var message = "audio:pause:".concat(encodeURIComponent(id));
      WebkitCallback.postMessage(message);
    }
  }, {
    key: "audioPlay",
    value: function audioPlay(id, url, title, required, startTime) {
      var message = "audio:play:".concat(encodeURIComponent(id), ",").concat(encodeURIComponent(url), ",").concat(encodeURIComponent(title), ",").concat(encodeURIComponent(required), ",").concat(encodeURIComponent(startTime));
      WebkitCallback.postMessage(message);
    }
  }, {
    key: "authRevoke",
    value: function authRevoke() {
      var message = 'auth:revoke';
      WebkitCallback.postMessage(message);
    }
  }, {
    key: "chapterChange",
    value: function chapterChange(fromId, toId) {
      var message = "chapter:change:".concat(encodeURIComponent(fromId), ",").concat(encodeURIComponent(toId));
      WebkitCallback.postMessage(message);
    }
  }, {
    key: "chapterCompleted",
    value: function chapterCompleted(id) {
      WebkitCallback.postMessage("chapterCompleted:".concat(id));
    }
  }, {
    key: "qrScannerOpen",
    value: function qrScannerOpen() {
      WebkitCallback.postMessage('qrScanner:open');
    }
  }, {
    key: "fullScreenChange",
    value: function fullScreenChange(fullScreen) {
      WebkitCallback.postMessage("fullScreenChange:".concat(String(fullScreen)));
    }
  }, {
    key: "openPDF",
    value: function openPDF(url) {
      WebkitCallback.postMessage("pdf:".concat(url));
    }
  }, {
    key: "playAudio",
    value: function playAudio(title, uri) {
      var message = "audio:".concat(colonToDash(title), ":").concat(uri);
      WebkitCallback.postMessage(message);
    }
  }, {
    key: "videoEnded",
    value: function videoEnded(url) {
      WebkitCallback.postMessage("videoEnded:".concat(url));
    }
  }, {
    key: "videoPause",
    value: function videoPause(url) {
      WebkitCallback.postMessage("videoPause:".concat(url));
    }
  }, {
    key: "videoPlay",
    value: function videoPlay(url) {
      WebkitCallback.postMessage("videoPlay:".concat(url));
    }
  }, {
    key: "videoPlayFullScreen",
    value: function videoPlayFullScreen(url) {
      WebkitCallback.postMessage("videoPlayFullScreen:".concat(url));
    }
  }, {
    key: "postMessage",
    value: function postMessage(message) {
      Logger.info("[Web->Native] ".concat(message), {}, {
        sentry: false
      });

      if (UserAgent.isAndroid()) {
        try {
          Android.postMessage(message);
        } catch (error) {
          Logger.warning(error.message, {}, {
            sentry: false
          });
        }
      }

      if (UserAgent.isIOS()) {
        webkit.messageHandlers.callbackHandler.postMessage(message);
      }
    }
  }, {
    key: "renderCompleted",
    value: function renderCompleted() {
      WebkitCallback.postMessage('renderCompleted');
    }
  }]);

  return WebkitCallback;
}();

export default WebkitCallback;